import { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

export default function useOpenLinkedForm(bindingIndex: number, name: string) {
	const newLink = useMemo(
		() => ({ bindingIndex, name }),
		[bindingIndex, name]
	);

	const history = useHistory();

	const openLinkedForm = useCallback(
		(index = 0, newRecord = false) => {
			const links = [{ ...newLink, index, newRecord }];
			let otherParams = "";

			const searchParams = new URLSearchParams(history.location?.search);

			// Iterate the search parameters
			for (const p of searchParams) {
				p[0] === "linked"
					? links.unshift(...JSON.parse(p[1]))
					: (otherParams += `&${p[0]}=${p[1]}`);
			}

			history.push(`?linked=${JSON.stringify(links)}${otherParams}`);
		},
		[history, newLink]
	);

	return { openLinkedForm };
}
